import { select, useDispatch } from '@ps/web-core-store';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import useOpenActiveGame from '../useOpenActiveGame';

const useTournamentTakeSeat = (id?: number) => {
  const { focusActiveGame } = useOpenActiveGame();
  const isEmbedded = useSelector(select.device.isEmbedded);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const { modal } = useDispatch();

  return useCallback((): void => {
    if (!id) return;

    if (isEmbedded) {
      return window.starsweb?.app?.execute?.(`tournament/${id}`);
    }

    if (isAuthenticated) {
      focusActiveGame({ id });
    } else {
      modal.unshift({ path: '/auth/login' });
    }
  }, [id, isAuthenticated, isEmbedded, modal, focusActiveGame]);
};

export default useTournamentTakeSeat;
